import { StyleSheet } from "react-native";
import { colorList } from 'utils/colors'

export const buttonStyles = StyleSheet.create({
	indicator: {
		justifyContent: 'center',
		alignItems: 'center',
		width: 16,
		height: 16,
	},
	iconContainer: {
		// flex: 1,
		width: 19,
		height: 19,
		justifyContent: 'center',
		alignItems: 'center',
	},
	iconContainerLeft: {
		// marginHorizontal: 12,
	},
	iconContainerRight: {
		// marginHorizontal: 12,
	},
	
	button: {
		height: 'auto',
		width: 'auto',
		minWidth: 120,
		backgroundColor: colorList.PRIMARY.primary
	},
	buttonText: {
		color: colorList.WHITE.primary,
	},

	buttonSmall: {
		padding: 4,
		paddingVertical: 6,
	},
	buttonSmallText: {
		fontSize: 12,
	},
	buttonLarge: {
		padding: 12,
		paddingVertical: 16,
	},
	buttonLargeText: {
		fontSize: 16,
	},
	buttonDefault: {
		padding: 8,
		paddingVertical: 12,
	},
	buttonDefaultText: {
		fontSize: 14,
	},

	buttonOutline: {
		borderWidth: 1,
		borderColor: colorList.PRIMARY.primary,
		backgroundColor: 'transparent',
	},
	buttonOutlineText: {
		color: colorList.PRIMARY.primary,
	},

	buttonGhost: {
		backgroundColor: 'transparent',
		borderWidth: 0,
	},
	buttonGhostText: {
		color: colorList.PRIMARY.primary,
		// opacity: 0.8,
	},

	buttonInverse: {
		backgroundColor: colorList.WHITE.primary,
		borderWidth: 0,
	},
	buttonInverseText: {
		color: colorList.PRIMARY.primary,
	},
	
	buttonText: {
		fontWeight: 'bold',
		flex: 1,
		textAlign: 'center',
		color: '#ffffff',
	},
});
